import {h, Fragment} from "preact"
export default function QuickBuySizeList({
    productName,
    productOptions,
    isSizeAvailable,
    isAddingToCart,
    selectedSize,
    onQuickBuy
}) {
    return (
        <div class="ns-quick-buy-options">
            <div class="ns-quick-buy-options-wrapper">
                {productOptions.map((size) => {
                    const available = isSizeAvailable(size)
                    const isLoading = isAddingToCart && selectedSize === size
                    const isDisabled = !available

                    return (
                        <button
                            key={size}
                            type="button"
                            class={`ns-quick-buy-option ${isDisabled ? 'ns-disabled' : ''} ${isLoading ? 'ns-loading' : ''}`}
                            onClick={(event) => {
                                event.preventDefault()
                                event.stopPropagation()
                                if (!isDisabled && !isAddingToCart) {
                                    onQuickBuy(size)
                                }
                            }}
                            onKeyDown={(event) => {
                                if ((event.key === 'Enter' || event.key === ' ') && !isDisabled && !isAddingToCart) {
                                    event.preventDefault()
                                    event.stopPropagation()
                                    onQuickBuy(size)
                                }
                            }}
                            aria-label={`Quick buy ${productName} ${size} ${isDisabled ? 'Unavailable' : ''}`}
                            aria-disabled={isDisabled}
                            tabIndex={isDisabled ? -1 : undefined}
                        >
                            <span>{size}</span>
                        </button>
                    )
                })}
            </div>
        </div>
    )
}
